/* ============================================================
   ctr-faq — accordion (one item open at a time) and
   "view more" toggle for extra questions.
   ============================================================ */

(function () {
  'use strict';

  function initSection(root) {
    if (root.dataset.ctrFaqInit) return;
    root.dataset.ctrFaqInit = 'true';

    var items = root.querySelectorAll('.ctr-faq__item');

    items.forEach(function (item) {
      var question = item.querySelector('.ctr-faq__question');
      if (!question) return;

      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          var btn = other.querySelector('.ctr-faq__question');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          question.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var moreBtn = root.querySelector('[data-ctr-more]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var hidden = root.querySelectorAll('.ctr-faq__item.is-hidden');
        var expanded = moreBtn.dataset.ctrExpanded === 'true';

        if (expanded) {
          root.querySelectorAll('.ctr-faq__item.is-expanded').forEach(function (item) {
            item.classList.add('is-hidden');
            item.classList.remove('is-expanded', 'is-open');
          });
          moreBtn.dataset.ctrExpanded = 'false';
          moreBtn.textContent = moreBtn.dataset.moreLabel;
        } else {
          hidden.forEach(function (item) {
            item.classList.remove('is-hidden');
            item.classList.add('is-expanded');
          });
          moreBtn.dataset.ctrExpanded = 'true';
          moreBtn.textContent = moreBtn.dataset.lessLabel;
        }
      });
    }
  }

  function initAllSections() {
    document.querySelectorAll('[data-ctr-faq]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', initAllSections);
})();
